import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const navItems = [
    { to: '/dashboard', label: 'Dashboard', icon: '📊' },
    { to: '/models', label: 'Models', icon: '👤' },
    { to: '/productions', label: 'Productions', icon: '🎬' },
    { to: '/documents', label: 'Documents', icon: '📄' },
    { to: '/compliance', label: 'Compliance', icon: '✓' },
  ];

  const adminNavItems = [
    { to: '/users', label: 'Users', icon: '👥' },
    { to: '/settings', label: 'Settings', icon: '⚙️' },
  ];

  const superAdminItems = [
    { to: '/admin/tenants', label: 'Studios', icon: '🏢' },
    { to: '/admin/backups', label: 'Backups', icon: '💾' },
  ];

  return (
    <div className="layout">
      <aside className="sidebar">
        <div className="sidebar-header">
          <h1 className="logo">MediaRite</h1>
        </div>

        <nav className="nav">
          <ul className="nav-list">
            {navItems.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  className={({ isActive }) =>
                    `nav-link ${isActive ? 'active' : ''}`
                  }
                >
                  <span className="nav-icon">{item.icon}</span>
                  <span>{item.label}</span>
                </NavLink>
              </li>
            ))}
          </ul>

          {(user?.role === 'studio_admin' || user?.role === 'super_admin') && (
            <>
              <div className="nav-divider" />
              <ul className="nav-list">
                {adminNavItems.map((item) => (
                  <li key={item.to}>
                    <NavLink
                      to={item.to}
                      className={({ isActive }) =>
                        `nav-link ${isActive ? 'active' : ''}`
                      }
                    >
                      <span className="nav-icon">{item.icon}</span>
                      <span>{item.label}</span>
                    </NavLink>
                  </li>
                ))}
              </ul>
            </>
          )}

          {user?.role === 'super_admin' && (
            <>
              <div className="nav-divider" />
              <div className="nav-section-title">Super Admin</div>
              <ul className="nav-list">
                {superAdminItems.map((item) => (
                  <li key={item.to}>
                    <NavLink
                      to={item.to}
                      className={({ isActive }) =>
                        `nav-link ${isActive ? 'active' : ''}`
                      }
                    >
                      <span className="nav-icon">{item.icon}</span>
                      <span>{item.label}</span>
                    </NavLink>
                  </li>
                ))}
              </ul>
            </>
          )}
        </nav>

        <div className="sidebar-footer">
          <div className="user-info">
            <span className="user-email">{user?.email}</span>
            <span className="user-role">{user?.role}</span>
          </div>
          <button onClick={handleLogout} className="logout-btn">
            Logout
          </button>
        </div>
      </aside>

      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}
